import { ContentList, Header, Sidebar } from './components';

const Home = () => {
  return (
    <section className="max-w-[1200px] mx-auto flex h-[calc(100vh-24px)] my-3 gap-3">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <main className="flex min-w-0 flex-1 flex-col gap-5 rounded-xl bg-white px-6 py-8">
        {/* Header */}
        <Header />

        {/* Content List */}
        <ContentList />
      </main>
    </section>
  );
};

export default Home;
